(() => {
  const ROOT_SELECTOR = '[data-lucien-audio-widget]';
  const COMPONENT_SELECTOR = '.commonninja_component';
  const STYLE_ID = 'lucien-audio-widget-shadow-style';
  const COMMONNINJA_SRC = 'https://cdn.commoninja.com/sdk/latest/commonninja.js';
  const COMMONNINJA_SCRIPT_ID = 'lucien-commonninja-sdk';

  let commonNinjaLoadPromise = null;

  const shadowCss = `
    .plugin-wrapper,
    .plugin-wrapper * {
      box-sizing: border-box !important;
      font-family: Roboto, Arial, sans-serif !important;
    }

    .plugin-wrapper {
      width: 100% !important;
      max-width: 454px !important;
      background: transparent !important;
      font-size: 14px !important;
      line-height: 1.2 !important;
    }

    .audio-player-container {
      width: 454px !important;
      max-width: 454px !important;
      height: fit-content !important;
      min-height: fit-content !important;
      padding: 0 !important;
      background-color: #fffefc !important;
      border-radius: 6px !important;
      box-shadow: none !important;
      overflow: hidden !important;
    }

    .audio-player {
      display: grid !important;
      grid-template-columns: 88px minmax(0, 1fr) !important;
      grid-template-rows: auto !important;
      column-gap: 16px !important;
      align-items: start !important;
      width: 100% !important;
    }


    .jDTOfQ.wrapper .audio-player {
     margin: 10px 0 !important;
    }




    .top-wrapper {
      grid-column: 1 !important;
      grid-row: 1 !important;
      width: 88px !important;
      height: 88px !important;
      margin: 0 !important;
    }

    .audio-img {
      display: block !important;
      width: 88px !important;
      height: 88px !important;
      min-width: 88px !important;
      min-height: 88px !important;
      object-fit: cover !important;
      border-radius: 2px !important;
    }

    .audio-content {
      grid-column: 2 !important;
      grid-row: 1 !important;
      min-width: 0 !important;
      width: 100% !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    .audio-details {
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .audio-details h3 {
      margin: 0 0 8px !important;
      color: #334324 !important;
      font-size: 13px !important;
      font-weight: 700 !important;
      line-height: 1.16 !important;
    }

    .audio-details .subtitle {
      display: -webkit-box !important;
      margin: 0 !important;
      overflow: hidden !important;
      color: #111 !important;
      font-size: 11px !important;
      font-weight: 400 !important;
      line-height: 1.15 !important;
      -webkit-box-orient: vertical !important;
      -webkit-line-clamp: 5 !important;
    }

    .audio-actions {
      grid-column: 1 / -1 !important;
      width: 100% !important;
      margin: 11px 0 0 !important;
      padding: 0 !important;
    }

    .audio-player-btns-wrapper,
    .slider-wrapper {
      width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .slider-time {
      display: block !important;
      margin: 0 0 5px !important;
      height: 15px !important;
    }

    .slider-time p {
      margin: 0 !important;
      color: #111 !important;
      font-size: 12px !important;
      line-height: 1 !important;
    }

    .slider-time p + p {
      display: none !important;
    }

    .audio-slider {
      width: 100% !important;
      height: 6px !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .rc-slider-rail,
    .rc-slider-track {
      height: 4px !important;
      border-radius: 999px !important;
    }

    .rc-slider-rail {
      background: #cfd2c9 !important;
    }

    .rc-slider-track,
    .rc-slider-handle {
      background: #111 !important;
    }

    .rc-slider-handle {
      width: 9px !important;
      height: 9px !important;
      margin-top: -3px !important;
      border: 0 !important;
      box-shadow: none !important;
      opacity: 1 !important;
    }

    .audio-player-buttons {
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      width: 100% !important;
      margin: 10px 0 0 !important;
      padding: 0 !important;
    }

    .audio-player-action-btns {
      display: flex !important;
      align-items: center !important;
      gap: 14px !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    .audio-player-action-btns button,
    .audio-player-buttons button {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 22px !important;
      height: 22px !important;
      padding: 0 !important;
      color: #111 !important;
      background: transparent !important;
      border: 0 !important;
      font-size: 20px !important;
    }

    .audio-player-extras-action,
    .react-player {
      display: none !important;
    }

    @media (max-width: 749px) {
      .plugin-wrapper,
      .audio-player-container {
        width: min(330px, 100%) !important;
        max-width: 330px !important;
      }

      .audio-player-container {
        min-height: 210px !important;
        padding: 0px !important;
      }

      .audio-player {
        grid-template-columns: 74px minmax(0, 1fr) !important;
        column-gap: 14px !important;
      }

      .top-wrapper,
      .audio-img {
        width: 74px !important;
        height: 74px !important;
        min-width: 74px !important;
        min-height: 74px !important;
      }

      .audio-details h3 {
        font-size: 13px !important;
      }

      .audio-details .subtitle {
        font-size: 11px !important;
        -webkit-line-clamp: 5 !important;
      }
    }
  `;

  const injectStyle = (component) => {
    if (!component || !component.shadowRoot) return false;
    if (component.shadowRoot.getElementById(STYLE_ID)) return true;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = shadowCss;
    component.shadowRoot.appendChild(style);
    return true;
  };

  const findExistingCommonNinjaScript = (src) => {
    return document.getElementById(COMMONNINJA_SCRIPT_ID)
      || Array.from(document.scripts).find((script) => script.src && script.src.indexOf(src) === 0);
  };

  const loadCommonNinja = (src = COMMONNINJA_SRC) => {
    if (commonNinjaLoadPromise) return commonNinjaLoadPromise;

    commonNinjaLoadPromise = new Promise((resolve, reject) => {
      const existingScript = findExistingCommonNinjaScript(src);

      if (existingScript) {
        if (existingScript.dataset.commonninjaLoaded === 'true') {
          resolve();
          return;
        }

        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
        window.setTimeout(resolve, 1500);
        return;
      }

      const script = document.createElement('script');
      script.id = COMMONNINJA_SCRIPT_ID;
      script.src = src;
      script.async = true;
      script.defer = true;

      script.addEventListener('load', () => {
        script.dataset.commonninjaLoaded = 'true';
        resolve();
      }, { once: true });

      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });

    return commonNinjaLoadPromise;
  };

  const styleSection = (section) => {
    const components = Array.from(section.querySelectorAll(COMPONENT_SELECTOR));
    if (!components.length) return;

    let attempts = 0;
    const maxAttempts = 80;

    const tick = () => {
      attempts += 1;
      const ready = components.every(injectStyle);
      if (ready || attempts >= maxAttempts) return;
      window.setTimeout(tick, 100);
    };

    tick();
  };

  const loadAndStyleSection = (section) => {
    if (!section || section.dataset.lucienAudioWidgetLoaded === 'true') return;

    section.dataset.lucienAudioWidgetLoaded = 'true';

    loadCommonNinja(section.dataset.commonninjaSrc || COMMONNINJA_SRC)
      .then(() => {
        styleSection(section);
      })
      .catch(() => {
        section.dataset.lucienAudioWidgetLoadFailed = 'true';
        styleSection(section);
      });
  };

  const observeSection = (section) => {
    if (!section || section.dataset.lucienAudioWidgetObserved === 'true') return;

    section.dataset.lucienAudioWidgetObserved = 'true';

    if (!('IntersectionObserver' in window)) {
      loadAndStyleSection(section);
      return;
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        currentObserver.unobserve(entry.target);
        loadAndStyleSection(entry.target);
      });
    }, {
      rootMargin: '600px 0px',
      threshold: 0.01
    });

    observer.observe(section);
  };

  const init = (root = document) => {
    const sections = Array.from(root.querySelectorAll(ROOT_SELECTOR));

    if (root.matches && root.matches(ROOT_SELECTOR)) {
      sections.unshift(root);
    }

    sections.forEach(observeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
